export const FEATURES_LIST = [{
  title: '启动快，占用小',
  desc: '登录速度<1S，启动时平均占用内存为37M左右',
  img: 'mac-version/启动快，占用小.jpg'
}, {
  title: '看行情，不卡顿',
  desc: '超低延迟占比高，100ms+仅占11%',
  img: 'mac-version/看行情，不卡顿.jpg'
}, {
  title: '低崩溃，高稳定',
  desc: '崩溃率仅1.4‰，而业内平均3～4‰',
  img: 'mac-version/低崩溃，高稳定.jpg'
}, {
  title: '完美适配原生系统',
  desc: '支持快捷手势交互操作及分屏页面功能，大幅提高看盘效率',
  img: 'mac-version/精细运营.jpg'
}];
export const SKILL_LIST = [{
  img: 'FeaturedKanban.png',
  title: '特色看盘',
  desc: '根据用户使用习惯上线了全景看盘、多股报价、热力图及个性化模板定制功能；支持盘口上下滑动查阅及组件的增删修改，可以根据用户看盘习惯，便捷的组建专属私人盘口'
}, {
  img: 'HeaderSquare.png',
  title: '表头项广场',
  desc: '支持自然语言搜素的表头项定制和表头项模板广场功能可根据不同的用户推荐不同的表头项，真正帮助投资者做到“3000股票任你挑，你的地盘你做主'
}, {
  img: 'watchingAssistant.png',
  title: '盯盘助手',
  desc: '盯盘助手提供资讯（7X24H）、异动、行情三个模块，能够与看盘界面相融合，盯盘、看盘两不误'
}, {
  img: 'IntelligentInformation.png',
  title: '智能资讯',
  desc: '盘口支持新闻资讯、财务数据等股票关联信息的智能推荐。系统会对根据投资者偏好进行内容智能推荐展示，不仅丰富了盘口区域的功能，也优化了信息推荐'
}, {
  img: 'supportStore.png',
  title: '支持上线App Store',
  desc: '“涨停基因”功能通过统计个股近一年来触及涨停的情况，联动K线研判股性，有效帮助投资者把握跟风套利的机会'
}, {
  img: 'supportAn.png',
  title: '支持上证云方案',
  desc: '联合上证云将云行情由“保底收费”转为“计量收费”模式，大幅降低建设及运维成本'
}];